import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { SpaClassesPage } from '@features/spa/spa.types';

export const spaClassesPageKeys = {
  spaClassesPage: ['spaClassesPage'] as const,
  spaClassesPageKey: (propertyId: number, language: string) =>
    [...spaClassesPageKeys.spaClassesPage, propertyId, language] as const,
};

export function useGetSpaClassesPage(propertyId: number, language = 'en') {
  return useQuery({
    queryKey: spaClassesPageKeys.spaClassesPageKey(propertyId, language),
    queryFn: () => getSpaClassesPage(propertyId, language),
  });
}

export const getSpaClassesPagePrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  language: string
) =>
  queryClient.prefetchQuery(spaClassesPageKeys.spaClassesPageKey(propertyId, language), () =>
    getSpaClassesPage(propertyId, language)
  );

async function getSpaClassesPage(propertyId: number, language: string) {
  const response = await request.get(`${propertyId}/pages/spa-classes/${language}`);
  if (response.status === 204) {
    return null;
  }
  return response.data as SpaClassesPage;
}
